module finadai.app.negotiations {
  export var NAME = 'finadai.app.negotiations';
  function ConfigRoutes($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider) {
    $urlRouterProvider.when('/negotiations', '/negotiations/list');
    $stateProvider
      .state('app.negotiations', {
        templateUrl: 'app/negotiations/negotiations.tpl.html',
        url: '/negotiations',
      })
        .state('app.negotiations.paid', {
            templateUrl: 'app/negotiations/paid/paid.tpl.html',
            controller: 'NegotiationsPaidController',
            url: '/paid',
            resolve: {
                agents: (agentsService: services.AgentsService) => {
                    return agentsService.get();
                }
            }
        })
      .state('app.negotiations.list', {
        templateUrl: 'app/negotiations/list/list.tpl.html',
        controller: 'NegotiationsListController',
        url: '/list',
        resolve: {
          agents: (agentsService: services.AgentsService) => {
            return agentsService.get();
          }
        }
      })
      .state('app.negotiations.create', {
        templateUrl: 'app/negotiations/detail/detail.tpl.html',
        // url: '/create/:creditId',
        url: '/create/:customerId/:activityId',
        controller: 'NegotiationDetailController',
        controllerAs: 'vm',
        resolve: {
          // credit: (negotiationsService: services.NegotiationsService, $stateParams) => {
          //   return negotiationsService.getCredit($stateParams.creditId);
          // },
          credits: (negotiationsService: services.NegotiationsService, $stateParams) => {
            return negotiationsService.getCredits({ with: "customer,negotiation,loan_type", customer_id: $stateParams.customerId });
          },
          verifyCredit: (credits: ng.IHttpPromiseCallbackArg<models.http.responses.Records<models.Credit>>, $q: ng.IQService, $state: ng.ui.IStateService, notify, $rootScope: ng.IRootScopeService, whoIAm: models.User) => {
            var creditsWithCompleteNegotiation = credits.data.data.filter(x => angular.isDefined(x.negotiation) && x.negotiation.state == 'complete');
            var creditsWithNotCompleteNegotiation = credits.data.data.filter(x => angular.isDefined(x.negotiation) && x.negotiation.state != 'complete');
            if (creditsWithCompleteNegotiation.length > 0) {
                notify("Al menos un crédito ya se encuentra en una negociación", 'danger');
                $rootScope.$broadcast('preloader:hide');
                if (whoIAm.privilege == 'customer') {
                    $state.go('app.customers.profile');
                }
                else {
                    $state.go('app.customers.detail', {customerCode: credits.data.data[0].customer_number});
                }
            }
            if (creditsWithNotCompleteNegotiation.length > 0) {
                $rootScope.$broadcast('preloader:hide');
                $state.go('app.negotiations.detail', {negotiationId: credits.data.data[0].negotiation.id});
            }
            return true;
          },
          negotiation: () => { return null; }
        }
      })
      .state('app.negotiations.detail', {
        templateUrl: 'app/negotiations/detail/detail.tpl.html',
        url: '/detail/:negotiationId',
        controller: 'NegotiationDetailController',
        controllerAs: 'vm',
        resolve: {
          negotiation: (negotiationsService: services.NegotiationsService, $stateParams) => {
            return negotiationsService.get($stateParams.negotiationId);
          },
          credits: () => { return null; }
        }
      });
  }
  export function run() {
    var negotiations = angular.module(NAME, [
      finadai.app.negotiations.detail.NAME,
      finadai.app.negotiations.list.NAME,
      finadai.app.negotiations.paid.NAME
    ]);
    negotiations.config(ConfigRoutes);
  }
} finadai.app.negotiations.run();